import api from '../client'

/**
 * Paginated, searchable employee option fetcher for AppCombobox lazy loading.
 * Calls /options/employees with 3-char search and on-scroll pagination.
 * Returns { items: [{ value, label, id, name, code, group }], hasMore: boolean }
 */
export async function fetchEmployeeOptions(search = '', page = 1, pageSize = 20) {
  const params = { search, page, page_size: pageSize }
  const { data } = await api.get('/options/employees', { params })
  const items = Array.isArray(data?.items) ? data.items : []
  const hasMore = Boolean(data?.has_more ?? (items.length === pageSize))
  return { items, hasMore }
}
